import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LOCALE_TYPE, CURRENT_LOCALES } from './const/localeType';
import en from './locale/en.json';
import ru from './locale/ru.json';
import kz from './locale/kz.json';

Vue.use(VueI18n);

const locales = {
  en,
  ru,
  kz,
};

const messages = {};

CURRENT_LOCALES.forEach((locale) => {
  messages[locale] = locales[locale];
});

const getUserLocale = () => {
  const currentLang = (window.navigator.language || window.navigator.userLanguage || '').toLowerCase();

  const locale =
    CURRENT_LOCALES.find((item) => {
      return currentLang.startsWith(item.toLowerCase());
    }) || CURRENT_LOCALES[0];

  localStorage.setItem('locale', locale);

  return locale;
};

const currentLocale = localStorage.getItem('locale') || getUserLocale();

const i18n = new VueI18n({
  locale: currentLocale,
  fallbackLocale: LOCALE_TYPE.RU,
  messages,
});

export default i18n;
